export default __webpack_public_path__ + "static/media/it.af6d5dcc.jpg";